/** @jsxImportSource @emotion/react */

import { Dispatch, FC, SetStateAction } from 'react'
import { findAllCheatSheetGroup_findAllCheatSheetGroup_items as IGroup } from '__generatedTypes__/findAllCheatSheetGroup'
import { SubjectExtendedFull } from 'hooks/usePlatformsAndSubjects'
import CheatSheetsGroups from './CheatSheetsGroups'
import CheatSheetsTabs from './CheatSheetsTabs'

interface IProps {
  selectedSubject: SubjectExtendedFull
  groups: IGroup[]
  setGroups: Dispatch<SetStateAction<IGroup[]>>
}

const CheatSheetsContent: FC<IProps> = ({ selectedSubject, groups, setGroups }) => (
  <>
    <CheatSheetsGroups groups={groups} setGroups={setGroups} selectedSubject={selectedSubject} />
    {groups.length > 0 && (
      <CheatSheetsTabs groups={groups} selectedSubjectId={selectedSubject.id} initialSelected={groups[0]} />
    )}
  </>
)

export default CheatSheetsContent
